import { render, staticRenderFns } from "./FeedList.vue?vue&type=template&id=5749163d"
import script from "./FeedList.vue?vue&type=script&lang=js"
export * from "./FeedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports